module.exports = __webpack_public_path__ + "img/cotton_fabric.36242b21.png";